<style lang="scss">
    .submission-page-preview {
        iframe {
            width: 70em;
            max-width: 100%;
            height: 36em;
            max-height: 48%;
        }
    }

    .titleoflink {
        max-width: 1200px;
        padding-right: 20px;
        word-break: normal;
    }

    .imageoflink {
        max-width: 260px;
        margin: auto;
        margin-right: 0;
        margin-top: 0;
    }
     .summary{
    max-width: 680px;
    width: 100%;
    display: inline-block;
    padding-top: 10px;
    }
    @media (max-width: 600px) {
    .imageoflink {
        display:none;
    }
    }

</style>

<template>
    <div class="link-list-info">
        <div class="titleoflink">
            <div class="info">

                <router-link
                        class="post_info"
                        v-text="submission.channel_title"
                        :to="channelUrl(submission.channel_name)"
                ></router-link>
                <router-link :to="/l/+submission.location.slug">({{submission.location.name}})</router-link> 
               <!-- <span> ({{submission.location.name}})</span>-->
                <!--<span class="set_background_color">Law</span>-->
                <!--<router-link class="post_info" v-text="list.channel_name"-->
                <!--:to="channelUrl(list.channel_name)"></router-link>-->

                <router-link
                        v-if="!submission.deleted_by"
                        class="post_info"
                        v-text="'posted by ' + submission.author.username"
                        :to="userUrl(submission.author.username)"
                ></router-link>
                <span v-else class="post_info" v-text="'[deleted]'"></span>

                <span>
                                <router-link class="date time_ago" v-text="date" :to="url_2"></router-link>
                            </span>
            </div>
            <h1 style="margin: 0;" class="submission-title">
                <a v-bind:href="submission.content.url" target="_blank" rel="nofollow">
                    {{ submission.title }}
                    <small class="go-gray" style="    font-size: 1.5vh;">- {{ submission.content.domain }}</small>

                    <el-tag
                            size="mini"
                            type="danger"
                            class="margin-left-half"
                            v-if="submission.nsfw"
                    >NSFW
                    </el-tag>
                </a>
            </h1>

          <div class="summary">
                        <span v-if="submission.content.description" style="font-weight:bold;"> Auto-Summary:</span>

                         <div v-html="submission.content.description"></div>
             </div>
        </div>
        <div class="imageoflink">
            <div v-if="submission.content.thumbnail_path" class="submission-page-preview">
                <div v-if="showEmbed" v-html="submission.content.embed" class="video-player-wrapper"></div>
                <div v-else>
                    <a :href="submission.content.url"
                       target="_blank"
                       rel="nofollow"
                       v-if="submission.content.thumbnail_path">
                        <img :src="submission.content.thumbnail_path"
                             :alt="submission.title"
                             style="max-height:180px;">
                    </a>
                </div>
            </div>
        </div>

        <!--<p  style="margin: 0px">{{submission.content.description}}</p>-->

    </div>
</template>

<script>
    import EmbedValidator from "../../mixins/EmbedValidator";
    import Markdown from "../../components/Markdown.vue";
    import Helpers from "../../mixins/Helpers";

    export default {
        mixins: [EmbedValidator, Helpers],

        props: [
            "nsfw",
            "submission",
            "url",
            "comments",
            "bookmarked",
            "points",
            "liked"
        ],

        data() {
            return {
                auth
            };
        },
        components: {
            Markdown
        },

        computed: {
            thumbnail() {
                return {
                    backgroundImage: "url(" + this.submission.content.thumbnail_path + ")"
                };
            },
            url_2() {
                return this.submissionUrl(this.submission);
            },
            date() {
                return this.parsDiffForHumans(this.submission.created_at);
            },

            showEmbed() {
                return this.isValidSourceForEmbed && this.submission.content.embed;
            },

            isVideo() {
                return this.submission.content.type == "video";
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/submission/LinkSubmission.vue